<template>
  <app-form-block
      :active="isInputActive"
      :errors="errors"
  >
    <template #label>
      <slot name="label"/>
    </template>

    <div
        :class="[
          'custom-textarea',
          { 'custom-textarea_disabled': disabled }
        ]"
        @click="$refs.textarea.focus()"
    >
    <textarea
        ref="textarea"
        v-model="computedModelValue"
        :maxlength="maxLength"
        :placeholder="placeholder"
        :disabled ="disabled"
        @input="handleInput"
        @keydown="keypress"
        @focus="focusIn()"
        @blur="focusOut()"
    />
      <div
          v-if="maxLength && isInputActive"
          class="custom-textarea__length"
      >
        {{(computedModelValue ?? "").length}} / {{ maxLength }}
      </div>
    </div>

    <slot />
  </app-form-block>
</template>

<script>
import AppFormBlock from "@/components/UI/AppFormBlock/AppFormBlock.vue";

export default {
  name: 'AppTextarea',
  components: { AppFormBlock },
  props: {
    disabled: Boolean,
    modelValue: String,
    maxLength: {
      type: Number,
    },
    maxHeight: {
      type: Number,
      default: 250
    },
    initHeight: {
      type: Number,
      default: 50
    },
    placeholder: {
      type: String
    },
    errors: {
      type: Array,
      default: () => []
    },
    maxLines: { type: [Number, null], default: null },
    submitOnEnter: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    focused: false,
    touched: false,
    isInputActive: false,
    initialHeight: null
  }),
  computed: {
    computedModelValue: {
      get () {
        return this.modelValue
      },
      set (newVal) {
        this.$emit('update:modelValue', newVal)
      }
    }
  },
  methods: {
    calculateHeight () {
      const textarea = this.$refs.textarea;

      if (!textarea) return;

      textarea.style.height = 'auto';

      const lineHeight = parseInt(getComputedStyle(textarea).lineHeight) || 20;
      const maxLinesHeight = this.maxLines ? this.maxLines * lineHeight : this.maxHeight;
      const newHeight = textarea.scrollHeight === 0 ? this.initHeight : textarea.scrollHeight;

      if (newHeight <= maxLinesHeight) {
        textarea.style.height = newHeight + 'px';
        textarea.style.overflowY = 'hidden';
      } else {
        textarea.style.height = maxLinesHeight + 'px';
        textarea.style.overflowY = 'auto'; // Показываем scroll
      }
    },

    focusIn() {
      this.isInputActive = true
    },
    focusOut() {
      if(this.computedModelValue) return;

      this.isInputActive = false
    },

    keypress(e) {
      const keyCode = e.which || e.keyCode;

      if (keyCode === 13) { // Enter
        if (e.metaKey) {
          e.preventDefault();
          this.computedModelValue += '\n'; // Добавляем перенос строки
        } else if (!e.shiftKey) {
          if (this.submitOnEnter) {
            e.preventDefault();
            this.$emit('submit', e);
          }
        }
      }
    },

    handleInput() {
      this.$nextTick(() => {
        this.calculateHeight()
      })
    }
  },
  mounted () {
    this.isInputActive = !!this.computedModelValue;
    this.calculateHeight();
  },
  watch: {
    computedModelValue() {
      this.calculateHeight();
      this.isInputActive = !!this.computedModelValue
    }
  }
}

</script>

<style lang="scss" src="./AppTextarea.scss" />